import { Switch, Form, Input } from "antd"
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SectionForm = ({ formValues, form }) => {
    const { t } = useTranslation();

    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="collapsible" label={t("Collapsible")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="defaultCollapse" label={t("Collapse by default")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="isQuestionnaireSection" label={t("Questionnaire Section")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

        </>
    )
}

export default SectionForm